<template>
  <!-- editMerchantModal -->
  <div
    id="editMerchantModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="editMerchantModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg">
      <form class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">
            {{ $t('label.affiliate.detail.addMerchant.editMerchant') }} : {{ merchantId }} <small> ( {{ $t('label.affiliate.detail.addMerchant.provider') }} : {{ providerId }} )</small>
          </h4>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
          />
        </div>
        <div class="modal-body">
          <div
            v-if="isModalProcessing"
            class="text-center"
          >
            <img
              src="@/assets/img/loader.gif"
              class="center-block"
            >
          </div>
          <div v-else>
            <div
              v-if="modalError"
              class="col "
            >
              <div
                class="alert alert-danger text-center border-0 shadow-sm rounded-0"
              >
                {{ $t('error.'+`${modalResponseErr}`) }}
              </div>
            </div>

            <div class="col ">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.detail.addMerchant.structureId') }}
                <span
                  :title="$t('label.affiliate.detail.addMerchant.structureIdInfo')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  class="label label-default ms-2"
                >
                  <i class="fa fa-info-circle fa-xs" />
                </span>
              </label>
              <input
                v-model="criterias.structureId"
                :placeholder="$t('label.affiliate.detail.addMerchant.structureId')"
                type="text"
                :class="status(v$.criterias.structureId)"
                class="form-control rounded-0"
              >
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="v$.criterias.structureId.$invalid">{{ $t('error.VALIDATION_FORMAT') }}</span>
              </p>
            </div>

            <div class="col ">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.detail.addMerchant.acceptanceChannels') }} *
                <span
                  :title="$t('label.affiliate.detail.addMerchant.acceptanceChannelsInfo')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  class="label label-default ms-2"
                >
                  <i class="fa fa-info-circle fa-xs" />
                </span>
              </label>
              <div class="form-check">
                <input
                  id="checkboxPdp"
                  v-model="criterias.checkboxPdp"
                  name="checkboxPdp"
                  class="form-check-input"
                  type="checkbox"
                >
                <label
                  class="form-check-label fw-bold mb-1"
                  for="checkboxPdp"
                >
                  {{ $t('label.affiliate.detail.addMerchant.acceptanceChannelsPDP') }}
                </label>
              </div>
              <div class="form-check">
                <input
                  id="checkboxVad"
                  v-model="criterias.checkboxVad"
                  name="checkboxVad"
                  class="form-check-input"
                  type="checkbox"
                >
                <label
                  class="form-check-label fw-bold mb-1"
                  for="checkboxVad"
                >
                  {{ $t('label.affiliate.detail.addMerchant.acceptanceChannelsVAD') }}
                </label>
              </div>
              <p
                v-if="validationError"
                class="error"
              >
                <span v-if="!v$.criterias.checkboxPdp.oneRequired || !v$.criterias.checkboxVad.oneRequired">{{ $t('error.VALIDATION_MANDATORY_CRITERIA') }}</span>
              </p>
            </div>

            <!-- Messages autorisés -->
            <div class="col">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.detail.addMerchant.allowedMessages') }}
                <span
                  :title="$t('label.affiliate.detail.addMerchant.allowedMessagesInfo')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  class="label label-default ms-2"
                >
                  <i class="fa fa-info-circle fa-xs" />
                </span>
              </label>
              <multiselect
                v-model="criterias.allowedMessages"
                :options="affiliateDetail.messageIdList"
                :searchable="false"
                :close-on-select="true"
                :multiple="true"
                :show-labels="true"
                class="rounded-0 select-tags"
                :placeholder="$t('label.affiliate.detail.addMerchant.allowedMessages')"
              />
            </div>

            <div class="col ">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.detail.addMerchant.filteringGroup1') }}
                <span
                  :title="$t('label.affiliate.detail.addMerchant.filteringGroup1Info')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  class="label label-default ms-2"
                >
                  <i class="fa fa-info-circle fa-xs" />
                </span>
              </label>
              <TagInput
                :tags="criterias.filteringGroup1"
                :tag-max-size="3"
                :tag-max-number="101"
                @new-tag="criterias.filteringGroup1 = $event;"
              />
            </div>

            <div class="col ">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.detail.addMerchant.filteringGroup2') }}
                <span
                  :title="$t('label.affiliate.detail.addMerchant.filteringGroup1Info')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  class="label label-default ms-2"
                >
                  <i class="fa fa-info-circle fa-xs" />
                </span>
              </label>
              <TagInput
                :tags="criterias.filteringGroup2"
                :tag-max-size="3"
                :tag-max-number="101"
                @new-tag="criterias.filteringGroup2 = $event;"
              />
            </div>

            <div class="col ">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.detail.addMerchant.filteringGroup3') }}
                <span
                  :title="$t('label.affiliate.detail.addMerchant.filteringGroup1Info')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  class="label label-default ms-2"
                >
                  <i class="fa fa-info-circle fa-xs" />
                </span>
              </label>
              <TagInput
                :tags="criterias.filteringGroup3"
                :tag-max-size="3"
                :tag-max-number="101"
                @new-tag="criterias.filteringGroup3 = $event;"
              />
            </div>

            <div class="col ">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.detail.addMerchant.filteringGroup4') }}
                <span
                  :title="$t('label.affiliate.detail.addMerchant.filteringGroup1Info')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  class="label label-default ms-2"
                >
                  <i class="fa fa-info-circle fa-xs" />
                </span>
              </label>
              <TagInput
                :tags="criterias.filteringGroup4"
                :tag-max-size="3"
                :tag-max-number="101"
                @new-tag="criterias.filteringGroup4 = $event;"
              />
            </div>

            <div class="col ">
              <label class="control-label fw-bold mb-1">
                {{ $t('label.affiliate.detail.addMerchant.filteringGroup5') }}
                <span
                  :title="$t('label.affiliate.detail.addMerchant.filteringGroup1Info')"
                  data-bs-toggle="tooltip"
                  data-bs-placement="left"
                  class="label label-default ms-2"
                >
                  <i class="fa fa-info-circle fa-xs" />
                </span>
              </label>
              <TagInput
                :tags="criterias.filteringGroup5"
                :tag-max-size="3"
                :tag-max-number="101"
                @new-tag="criterias.filteringGroup5 = $event;"
              />
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            id="closeEditMerchantModal"
            type="button"
            class="btn btn-default"
            data-bs-dismiss="modal"
          >
            {{ $t('button.cancel') }}
          </button>
          <BaseButton
            type="button"
            class="btn btn-primary"
            @click-base-button-event-emitter="editMerchant()"
          >
            {{ $t('button.edit') }}
          </BaseButton>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import { useVuelidate } from '@vuelidate/core'
import { maxLength } from '@vuelidate/validators'
import BaseButton from '@/components/BaseButton'
import TagInput from '@/components/TagInput'
import { ConnectionMode } from '@/enums/connection-mode.enum'
import { Modal } from 'bootstrap';
export default {
  components: {
    BaseButton,
    Multiselect,
    TagInput
  },
  props: {
    affiliateDetail: {
      type: Object,
      required: true
    }
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data () {
    return {
      criterias: {
        structureId: '',
        checkboxPdp: false,
        checkboxVad: false,
        allowedMessages: [],
        filteringGroup1: [],
        filteringGroup2: [],
        filteringGroup3: [],
        filteringGroup4: [],
        filteringGroup5: []
      },
      providerId: '',
      merchantId: '',
      isModalProcessing: false,
      modalError: false,
      validationError: false,
      connectionModeEnum: ConnectionMode
    }
  },
  created () {
  },

  methods: {
    show (provider, merchant) {
      this.isModalProcessing = true
      this.isModalProcessing = false
      this.modalError = false
      this.providerId = provider.providerId
      this.merchantId = merchant.merchantId
      this.criterias.structureId = merchant.structureId
      if (merchant.channelList.includes('pdp')) {
        this.criterias.checkboxPdp = true
      } else {
        this.criterias.checkboxPdp = false
      }
      if (merchant.channelList.includes('vad')) {
        this.criterias.checkboxVad = true
      } else {
        this.criterias.checkboxVad = false
      }
      this.criterias.allowedMessages = merchant.messageList
      this.criterias.filteringGroup1 = merchant.filteringGroup1 ? merchant.filteringGroup1 : []
      this.criterias.filteringGroup2 = merchant.filteringGroup2 ? merchant.filteringGroup2 : []
      this.criterias.filteringGroup3 = merchant.filteringGroup3 ? merchant.filteringGroup3 : []
      this.criterias.filteringGroup4 = merchant.filteringGroup4 ? merchant.filteringGroup4 : []
      this.criterias.filteringGroup5 = merchant.filteringGroup5 ? merchant.filteringGroup5 : []
      let editMerchantModal = new Modal(document.getElementById('editMerchantModal'))
      editMerchantModal.show()
      this.isModalProcessing = false
    },
    status (validation) {
      return {
        'validation-error': validation.$invalid && this.validationError
      }
    },
    editMerchant () {
      this.validationError = this.v$.$invalid

      if (!this.validationError) {
        this.runeditMerchant()
      }
    },
    async runeditMerchant () {
      this.isModalProcessing = true
      this.modalResponseErr = null

      await this.$store.dispatch('affiliates/updateMerchant', {
        contractId: this.affiliateDetail.contractId,
        distributorRef: this.affiliateDetail.distributorId,
        commercialProduct: this.affiliateDetail.productId,
        providerId: this.providerId,
        merchantId: this.merchantId,
        structureId: this.criterias.structureId,
        checkboxPdp: this.criterias.checkboxPdp,
        checkboxVad: this.criterias.checkboxVad,
        allowedMessages: this.criterias.allowedMessages,
        filteringGroup1: this.criterias.filteringGroup1,
        filteringGroup2: this.criterias.filteringGroup2,
        filteringGroup3: this.criterias.filteringGroup3,
        filteringGroup4: this.criterias.filteringGroup4,
        filteringGroup5: this.criterias.filteringGroup5,
        affiliateEditMode: true
      }).then(
        () => {
          this.isModalProcessing = false
          this.modalError = false
          document.getElementById('closeEditMerchantModal').click()
        },
        error => {
          this.isModalProcessing = false
          this.modalError = true
          this.modalResponseErr = error.data.errorCode
        }
      )
    }
  },

  validations() {
    return {
      criterias: {
        structureId: { maxLength: maxLength(45) },
        checkboxPdp: {
          oneRequired () {
            return (
              this.criterias.checkboxPdp ||
              this.criterias.checkboxVad
            )
          }
        },
        checkboxVad: {
          oneRequired () {
            return (
              this.criterias.checkboxPdp ||
              this.criterias.checkboxVad
            )
          }
        },
        allowedMessages: { },
        filteringGroup1: { },
        filteringGroup2: { },
        filteringGroup3: { },
        filteringGroup4: { },
        filteringGroup5: { }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.error {
  color: red;
}

.validation-error {
  border-color: red;
  background: #FDD;

  &:focus {
    outline-color: rgb(250, 28, 28);
  }
}

</style>
